/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

   // Sélectionne tous les conteneurs où insérer le sélecteur de quantité
const conteneurs = document.getElementsByClassName('product-item__info');

// Vérifie qu'il y a au moins un conteneur
// if (conteneurs.length > 0) {
//     // HTML du sélecteur de quantité
//     const quantitySelectorHTML = `
//         <quantity-selector class="quantity-selector bordder_color">
//             <button type="button" class="quantity-selector__button" aria-label="Réduire la quantité">
//                 <span class="visually-hidden">Réduire la quantité</span>
//                 <svg focusable="false" width="10" height="2" class="icon icon--minus-big" viewBox="0 0 10 2">
//                     <path fill="currentColor" d="M0 0h10v2H0z"></path>
//                 </svg>
//             </button>
//             <input 
//                 type="number" 
//                 form="product-form-main-12378800587092-template--26804152009044__main" 
//                 is="input-number" 
//                 class="quantity-selector__input is-filled" 
//                 inputmode="numeric" 
//                 name="quantity" 
//                 autocomplete="off" 
//                 value="1" 
//                 step="1" 
//                 min="1" 
//                 aria-label="Quantité" 
//                 style="--quantity-selector-character-count: 1ch;"
//             >
//             <button type="button" class="quantity-selector__button" aria-label="Augmenter la quantité">
//                 <span class="visually-hidden">Augmenter la quantité</span>
//                 <svg focusable="false" width="10" height="10" class="icon icon--plus-big" viewBox="0 0 10 10">
//                     <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6v4h2V6h4V4H6V0H4v4H0v2h4z" fill="currentColor"></path>
//                 </svg>
//             </button>
//         </quantity-selector>
//     `;

//     // Insère le HTML dans chaque conteneur
//     Array.from(conteneurs).forEach(conteneur => {
//         conteneur.insertAdjacentHTML('beforeend', quantitySelectorHTML);
//     });
// }

// Charger jQuery si pas déjà présent
if (typeof jQuery === 'undefined') {
    var jq = document.createElement('script');
    jq.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
    jq.onload = function() { jQuery("button._formSubmitButton_cit2d_96").css("background", "#A04865"); };
    document.head.appendChild(jq);
} else {
    jQuery("button._formSubmitButton_cit2d_96").css("background", "#A04865");
}

document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", (e) => {
        const label = e.target.closest("label.tab-label");
        if (!label) return;

        // Active l'onglet cliqué
        document.querySelectorAll("label.tab-label").forEach(el => el.classList.remove("active"));
        label.classList.add("active");

        // Active le bon contenu
        const targetId = label.getAttribute("for"); // ou label.dataset.target
        if (targetId) {
            document.querySelectorAll(".tab-content").forEach(el => el.classList.remove("active"));
            document.getElementById(targetId)?.classList.add("active");
        }
    });
});